/* Polsk katalog for locale-bank-kje09-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'bank.group.toast.booked': 'Grupa dopasowania została zaksięgowana łącznie.',
  'bank.group.err.bookUnavailable': 'Grupa dopasowania została zatwierdzona, ale księgowanie jest niedostępne.',
  'bank.group.err.bookFailed': 'Nie udało się zaksięgować grupy dopasowania.',
  'bank.group.book': 'Zaksięguj grupę',
  'bank.resolve.reversePaymentInfo': 'Storno anuluje płatność z zachowaniem śladu, ponownie otwiera fakturę dostawcy i otwiera pozycję bankową do ponownej kontroli.',
  'err.bankMatchReversalReason': 'Podaj powód cofnięcia powiązania bankowego.',
});
